import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { sanity } from "../sanityClient";

const QUERY = `*[_type=="post" && slug.current==$slug][0]{ title, excerpt }`;

export default function PostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    sanity.fetch(QUERY, { slug }).then(setPost).catch(console.error);
  }, [slug]);

  if (!post) return <div style={{ color: "white", padding: 20 }}>Loading…</div>;

  return (
    <div style={{ color: "white", padding: 20 }}>
      <h1>{post.title}</h1>
      <p>{post.excerpt}</p>
      <p>(Next we’ll render the full body.)</p>
    </div>
  );
}